export var toggleRadioOnAlt = [
    'M7.81 2C4.6 2 2 4.63 2 7.81C2 11.02 4.6 13.63 7.81 13.63C11 13.63 13.63 11.02 13.63 7.81C13.63 4.63 11 2 7.81 2ZM7.81 12.88C5.02 12.88 2.75 10.63 2.75 7.81C2.75 5.05 5 2.75 7.81 2.75C10.58 2.75 12.88 5.02 12.88 7.81C12.88 10.6 10.6 12.88 7.81 12.88Z',
    'M10.62 7.81C10.62 9.36 9.36 10.62 7.81 10.62C6.26 10.62 5 9.36 5 7.81C5 6.26 6.26 5 7.81 5C9.36 5 10.62 6.26 10.62 7.81Z',
];
